export type ColorScheme = "light" | "dark";
export type ColorSchemeWriteTarget = "both" | ColorScheme;

export function isColorScheme(value: unknown): value is ColorScheme {
  return value === "light" || value === "dark";
}

export function isColorSchemeWriteTarget(
  value: unknown,
): value is ColorSchemeWriteTarget {
  return value === "both" || isColorScheme(value);
}
